module.exports = __webpack_public_path__ + "img/orthotic-stability.0ce0a79d.png";